// src/controllers/mapController.js

import useSelectionStore from "@store/useSelectionStore";
import { ClickDTO } from '@models/ClickDTO';
import { ClickableType } from '@utils/enums';
import useGameStore from '@store/useGameStore';

/**
 * Función central que decide qué hacer cuando se hace clic en el mapa.
 *
 * @param {number} x - Coordenada X del tile clickeado
 * @param {number} y - Coordenada Y del tile clickeado
 * @param {object|null} object - Objeto presente en el tile (unidad, beacon, etc.)
 */
export function handleTileClick(x, y, object) {
  const { handleClick } = useSelectionStore.getState();
  const gameId = useGameStore.getState().game?.id;

  let clickDTO;

  if (object) {
    // Handle object types
    let clickType;
    if (object.type === 'unit') {
      clickType = ClickableType.UNIT;
    } else if (object.type === 'structure') {
      clickType = ClickableType.STRUCTURE;
    } else {
      throw new Error(`[mapService] Unknown object type: ${object.type}`);
    }

    clickDTO = new ClickDTO(
      clickType,
      object,
      null,
      {
        position: { x, y },
        gameId,
        team: object.team || object.teamClass
      }
    );
  } else {
    // Empty tile clicked
    clickDTO = new ClickDTO(
      ClickableType.TILE,
      { x, y },
      null,
      { gameId }
    );
  }

  // Let the selection store handle it based on current context
  handleClick(clickDTO);
}

export function resetInteractionState() {
  const selection = useSelectionStore.getState();
  selection.clearAllSelections();
}